import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { getAllNofificationForDashboard } from 'src/thunks/dashboard';
import { GetError, TemplateForNotifications } from "src/constant";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Loader } from 'src/components/loader';


const ProjectManagerDashboard = () => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isDropdownOpenFlagValue, PMDashboardDropdownValues } = useSelector((state) => state.dashboard);
  const { selectedProjectDropdownValue } = useSelector((state) => state.goodsin);
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);

  console.log("pm dashboard dropdown value", PMDashboardDropdownValues)

  /** hooks useState ----------------------------------------------------- **/
  const [notificationsArray, setNotificationsArray] = useState({})
  const [loader, setLoader] = useState(false)

  //Variable Declarations
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));

  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    getProjectWiseNofn()
  }, [PMDashboardDropdownValues])

  /** handler functions--------------------------------------------------- **/
  const getProjectWiseNofn = async () => {
    const getNofnData = await getAllNotifications();
    let filteredData = [];
    if (PMDashboardDropdownValues?.clientId?.id && !PMDashboardDropdownValues?.projectId) {
      const filteredProjectsListFromClient = userDetails?.projects.filter(
        (project) => project?.clientId === PMDashboardDropdownValues?.clientId?.id
      );
      const filteredAllProjectIds = filteredProjectsListFromClient?.map((project) => project?.id);
      filteredData = getNofnData.filter((data) => filteredAllProjectIds?.includes(data.ProjectId));
    } else if (PMDashboardDropdownValues?.projectId) {
      filteredData = getNofnData.filter((data) => data.ProjectId == PMDashboardDropdownValues?.projectId?.id);
    } else {
      filteredData = getNofnData
    }
    const orderedData = _.orderBy(filteredData, ['TimeStamp'], ['desc']);
    const groupedData = _.groupBy(orderedData, (d) => moment(d.TimeStamp).format('DD-MMM-YYYY'));
    setNotificationsArray({ ...groupedData });
  }

  const getAllNotifications = async () => {
    try {
      setLoader(true)
      let res = await dispatch(getAllNofificationForDashboard());
      setLoader(false)
      return [...res.payload.result]
    } catch (error) {
      setLoader(false)
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  }

  if (loader) {
    return <Loader />
  }

  return (
    <>
      <div className={`mt-3 w-100 pm-dashboard-main-div ${isDropdownOpenFlagValue == true || signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""}`}>
        <div className='pm-dashboard-height-style'>
          {Object.keys(notificationsArray).length > 0 ? Object.keys(notificationsArray).map((date) => (
            <div key={date} className="ms-3 mt-2">
              <p className='pb-2 date-style-for-pm-nofn' style={{ borderBottom: "1px solid gray" }}>{date}</p>
              {notificationsArray[date].map((item, index) => (
                <div className='d-flex mb-2 project-manager-nofns'>
                  <span>{moment(item.TimeStamp).format("HH:mm")}</span>
                  <span className='ms-3' style={{ cursor: "pointer" }}>{TemplateForNotifications(item, navigate)}</span>
                </div>
              ))}
            </div>
          )) :
            <div className='d-flex justify-content-center align-items-center mt-3'>
              No notifications found.
            </div>
          }
        </div>
      </div>
    </>
  )
}

export default ProjectManagerDashboard
